import {
  SUPPORTED_JSON_VERSION,
} from '../constants/popularLocationsConstants';
import DIRECTION_TYPES from '../constants/directionConstants';

export const filterValidLocations = (locations) => locations.filter(
  ({ label, type, id }) => label && type && id
);

export const mapIntlPopularLocationsToLocationShape = (locations) => locations.map(
  ({ label, type, id }) => ({
    label,
    id,
    type,
    name: label,
    airportCode: id,
    parentId: '',
  }));

export const isLocationDefined = (location) => Object.values(location)
  .filter((value) => !!value).length > 0;

export const isValidDirection = (direction) => Object.values(DIRECTION_TYPES).includes(direction);

export const isSupportedVersion = (version) => {
  if (version) {
    return SUPPORTED_JSON_VERSION.toString() === version.toString();
  }
  return false;
};
